import { useTimezone } from '@app/core/hooks/useTimezone';
import { useTzFormat } from '@app/core/hooks/useTzFormat';
import { DateField, TimeField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../types';
import {
  combineDateWithExistingTime,
  combineTimeWithExistingDate,
} from './apply-gip-report-datetime';

export const FromField = () => {
  const { $t } = useIntl();
  const {
    values: { from },
    setFieldValue,
  } = useFormikContext<GipReportValues>();
  const tz = useTimezone();
  const formatTz = useTzFormat();

  return (
    <Grid container>
      <Grid item xs={12} md={7}>
        <DateField
          name="from"
          label={$t({
            id: 'audit.gipReport.form.startDate',
            defaultMessage: 'Fecha de inicio',
          })}
          max={formatTz(new Date(), 'YYYY-MM-DD')}
          isOutsideRange={(date) => moment(date) > moment()}
          onChange={(value) => {
            const next = combineDateWithExistingTime(from, value, tz);
            if (next !== null) {
              setFieldValue('from', next);
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TimeField
          name="from_time"
          label={$t({
            id: 'audit.gipReport.form.startTime',
            defaultMessage: 'Hora de inicio',
          })}
          value={
            from != null && from !== '' && moment(from).isValid()
              ? formatTz(from, 'HH:mm')
              : '00:00'
          }
          onChange={(event) => {
            const next = combineTimeWithExistingDate(from, event.currentTarget.value);
            if (next !== null) {
              setFieldValue('from', next);
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
